import React, { Component } from "react";
import { Spin } from "antd";

import { connect } from "react-redux";

import { loadComptes } from "../../../store/actions/compteAction";
import { loadEcritures } from "../../../store/actions/ecritureAction";

import TablePointe from "../../../components/TablePointe/index";

class Pointes extends Component {
  componentDidMount() {
    this.props.loadComptes();
    this.props.loadEcritures();
  }

  render() {
    const { comptes, ecritures, parametre } = this.props;
    const comptesFiltres = comptes?.filter(
      (compte) => compte.compte_type_compte !== "A"
      && compte.compte_compte_general.substring(0, 1) === "4"
      && compte.compte_compte_general.substring(0, 2) !== "48"  // Quittance recouvrement
      && compte.compte_compte_general.substring(0, 3) !== "418" // Centralisateur locataire
    );

    return (
      <Spin size="large" tip="Chargement en cours..." spinning={!comptes || !ecritures}>
        <div style={{ padding: 10 }}>
          <TablePointe
            comptes={comptesFiltres}
            ecritures={ecritures}
            parametre={parametre}
          />
        </div>
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadComptes: () => dispatch(loadComptes()),
    loadEcritures: () => dispatch(loadEcritures()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    comptes: state.comptes.data,
    ecritures: state.ecritures.data,
    parametre: state.parametre.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Pointes);
